import React, { Fragment, useEffect, useState } from "react";
import { Button } from 'primereact/button';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Chip } from 'primereact/chip';
import { loginRequest } from "../../config/sso_config";
import { callMsGraph } from './graph';
import { AuthService } from '../../services'
import { login, setRoles, setPermissions } from '../../services/store/userSlice';
import { parseRolePermission } from '../../services/utility/helper';
import CryptoJS from "crypto-js";
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { classNames } from 'primereact/utils';
import properties from "../../config/environmentProperties";
import { InputText } from 'primereact/inputtext';
import { useCookies } from "react-cookie";

const INIT_FORM_VAL = { email: null, semail: null, password: null, accept: false }
const SSOLogin = () => {
    const secretPass = "EXkShZPG4IfW2Rt2EW";
    const [cookies, setCookie] = useCookies(['token', 'msid']);
    const { instance, accounts } = useMsal();
    const [graphData, setGraphData] = useState(null);
    const [errMessage, setErrMessage] = useState(null);
    const isAuthenticated = useIsAuthenticated();
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [formData, setFormData] = useState({});
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const conf = properties.currentEnvironment;
    const formik = useFormik({
        initialValues: INIT_FORM_VAL,
        validate: (data) => {
            let errors = {};
            return errors;
        },
        onSubmit: (data) => {
            setFormData(data);
            loadProfile(data);
            setShowMessage(true);
            // formik.resetForm();
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    useEffect(() => {
        if (isAuthenticated) { RequestProfileData(); }
    }, [isAuthenticated]);

    function save2Local(user) {
        localStorage.setItem('email', user.email)
        localStorage.removeItem('inactive')
    }

    const RequestProfileData = () => {
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
        }).then((resp) => {
            setCookie('token', resp.accessToken);
            callMsGraph(resp.accessToken).then((response) => {
                setGraphData(response);
                setCookie('msid', response.id);
                setErrMessage('Successfully logged in, now page is redirecting to dashboard')
                if (response['mail'] == conf.serviceAccount) {
                    setLoggedIn(true);
                    formik.setFieldValue('email', response['mail']);
                } else {
                    setTimeout(() => {
                        const payload = {
                            email: response.mail,
                            password: response.id
                        }
                        getAuthorized(payload, resp.accessToken);
                    }, 5000);
                }

            });
        });
    }

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(e => {
                // console.log(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                // console.log(e);
            });
        }
    }

    const createSession = (userObj) => {
        const { roles, permissions } = parseRolePermission(userObj?.user?.UserRoles || []);
        userObj.user = (userObj.user ? userObj.user : {});
        userObj.user['roles'] = [(userObj?.user?.type === 'MANAGER' ? 'manager' : 'employee'), ...roles];
        userObj.user['show_roles'] = [...roles];
        userObj.user['permissions'] = permissions;
        userObj.user['loggedIn'] = true;
        delete (userObj.user['password']);
        const info = null;
        const result = { ...userObj, ...info }
        dispatch(login(result));
        dispatch(setRoles([(userObj.user.type === 'MANAGER' ? 'manager' : 'employee'), ...roles]));
        dispatch(setPermissions(permissions));
        save2Local(result);
    }

    const loadProfile = (params) => {
        const pwd = CryptoJS.AES.encrypt(JSON.stringify(params.password), secretPass).toString();
        const payload = { email: params.semail == null || params.semail == '' ? params.email : params.semail, password: cookies?.msid };
        try {
            AuthService.loginWithSSO(payload, cookies?.token).then(resp => {
                let userObj = resp.data;
                if (userObj.success) {
                    createSession(userObj);
                } else {
                    toast.error("User not found...");
                }
            }, err => {
                const errResp = err.response.data;
                toast.error(errResp.error);
            })
        } catch (error) {
            console.log("error on calling api", error)
        }
    }

    const logout = () => {
        const logoutRequest = {
            account: instance.getAccountByHomeId(accounts[0].homeAccountId),
            mainWindowRedirectUri: properties.currentEnvironment.redirectUrl,
            postLogoutRedirectUri: properties.currentEnvironment.redirectUrl,
        };
        instance.logoutPopup(logoutRequest);
    }

    const UserEmail = () => {
        return (
            <div className="p-fluid" style={{ textAlign: 'left' }}>
                <h2 style={{ color: '#0f0830', textAlign: 'center' }}>Logged-In with service account</h2>
                <p>
                    <Chip label="You can log in with a different email for service purposes." className="mr-2 mb-2 login-custom-chip" />
                </p>
                <form onSubmit={formik.handleSubmit} className="p-fluid">
                    <div className="field">
                        <label className={classNames({ 'p-error': isFormFieldValid('semail') })}>Email Address</label>
                        <span className="p-float-label p-input-icon-right">
                            <i className="pi pi-envelope" />
                            <InputText name="semail" value={formik.values.semail} onChange={formik.handleChange}
                                className={classNames({ 'p-invalid': isFormFieldValid('semail') })} placeholder="Enter your email address" />
                        </span>
                        {getFormErrorMessage('semail')}
                    </div>
                    <div className="grid">
                        <div className="col">
                            <Button type="submit" label="Go to Dashboard" className="mt-2" />
                        </div>
                        <div className="col">
                            <Button type="button" label="Logout" onClick={logout} className="p-button-secondary mt-2" />
                        </div>
                    </div>
                </form>

            </div>
        );
    }

    const getAuthorized = (data, accessToken = null) => {
        AuthService.loginWithSSO(data, accessToken).then(resp => {
            let userObj = resp.data;
            setErrMessage(null)
            if (userObj.success) {
                createSession(userObj);
            } else {
                // alert('hello')
            }
        }, error => {
            setErrMessage('Your account is inactive, please contact to ESS support team.')
        })
    }

    const ProfileContent = () => {
        return (
            <>
                <AuthenticatedTemplate>
                    {isLoggedIn ? UserEmail() : <>
                        <h2>Hi, {accounts[0].name.split(' ')[0]}</h2>
                        <p><Chip label={errMessage} className="mb-4 login-custom-chip" /></p>
                    </>}
                </AuthenticatedTemplate >
            </>
        );
    };
    return (
        <Fragment>
            {isAuthenticated ? ProfileContent() : <></>}
            {!isLoggedIn ? <><Button onClick={() => handleLogin("redirect")} label='LOGIN WITH SSO' /></> : <></>}

        </Fragment>
    )
}

export default SSOLogin;